const icon = require('vue-svgicon')

icon.register({
  'menu-close-icon': {
    width: 11,
    height: 18,
    viewBox: '0 0 11 18',
    data: '<path pid="0" d="M10.997 8.913a1.473 1.473 0 00-.45-.957L3.008.532a1.781 1.781 0 00-1.195-.53A1.829 1.829 0 00.556.406c-.34.282-.54.675-.555 1.094-.015.416.158.82.48 1.12L6.96 9 .48 15.38c-.321.301-.494.704-.48 1.121.016.418.216.813.556 1.094.342.282.794.427 1.256.402.46-.023.893-.213 1.196-.529l7.54-7.424c.313-.307.475-.714.45-1.131z" _fill="#3D4B55"/>',
  },
})
